import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import Link from 'next/link';

import useLinkProps from '../../../hooks/use-link-props';
import Carousel from '../../ui/carousel';
import DividerTop from '../../ui/icons/dividers/top';
import BackgroundLink from '../../ui/links/background';
import TextLink from '../../ui/links/text';

import RelatedProducts from './related-products';
import HasAdded from './top-banners/has-added';
import InCart from './top-banners/in-cart';
import IsSold from './top-banners/is-sold';
import Button from '../../ui/button';
import BPImage from '../../ui/v2/image';
import IconCircleIRounded from '../../ui/icons/circle-i-rounded';
import Trustpilot from '../../modules/trustpilot';
import Chevrelon from '../../ui/icons/cheverlon';
import FeaturedLink from '../../ui/links/featured';
import IconCheck from '../../ui/icons/check';
import Reviews from '../../modules/reviews';
import { useRouter } from 'next/router';

type BeforeContentProps = {
  productDetail: TProductDetail;
  hasAdded: boolean;
  relatedProducts: TProductListItem[] | undefined;
  setBeforeContentClose?: any;
};

const BeforeContent = ({
  productDetail,
  hasAdded,
  relatedProducts,
  setBeforeContentClose,
}: BeforeContentProps) => {
  const { t } = useTranslation();
  const getLinks = useLinkProps();
  const isSold = productDetail.status === 'SOL';
  const { push, locale = 'en' } = useRouter();

  //if (!isSold && !hasAdded && !productDetail.in_cart) return null;

  return (
    <>
      <div
        className={cx({
          'sticky top-0 z-10 w-full bg-red-10 p-4': isSold,
          'container mx-auto bg-yellow-10 mt-4 flex flex-row gap-4 px-4 items-center justify-center':
            !isSold && !hasAdded && productDetail.in_cart,
          'container mx-auto bg-green-10 mt-4 flex flex-row gap-4 px-4 items-center justify-center':
            !isSold && hasAdded,
        })}
      >
        {!isSold && !hasAdded && productDetail.in_cart ? (
          <>
            <IconCircleIRounded className="text-neutral-80 w-4 h-4 max-lg:w-12 max-lg:h-12"></IconCircleIRounded>
          </>
        ) : (
          <>
            {!isSold && hasAdded && (
              <IconCheck className="text-green-100 w-4 h-4 max-lg:w-12 max-lg:h-12"></IconCheck>
            )}
          </>
        )}

        {isSold && <IsSold productDetail={productDetail} />}
        {!isSold && hasAdded && <HasAdded />}
        {!isSold && !hasAdded && productDetail.in_cart && <InCart />}
      </div>
      {isSold && (
        <>
          {relatedProducts && (
            <RelatedProducts
              relatedProducts={relatedProducts}
              bgColor="bg-neutral-10"
            />
          )}
          <div className={cx('w-full  bg-neutral-10')}>
            <div
              className={cx(
                'w-full container mx-auto flex flex-row items-center justify-center bg-neutral-10',
                'text-center',
                'pb-14',
                {
                  'pt-14': !relatedProducts,
                }
              )}
            >
              <Button
                variant="GHOST-PRIMARY"
                isFullWidth={false}
                className="flex flex-row gap-6 items-center justify-center lg:justify-between"
                onClick={() => {
                  const link = getLinks('products', {
                    category: productDetail.part.subgroup_slug,
                    subCategory: productDetail.part.slug,
                    vehicle:
                      productDetail.car.version_slug ||
                      productDetail.car.model_slug,
                  });
                  push(link.href, link.as, { shallow: true });
                }}
              >
                <>{t('common:search-all-parts')}</>
                <Chevrelon className="w-4 h-4 text-brand-100 -rotate-90"></Chevrelon>
              </Button>
            </div>
          </div>
          <Reviews />
        </>
      )}
    </>
  );
};

export default BeforeContent;
